
const rankMap = {
    "PowerEdge_17": 1,
    "PowerEdge_16": 2,
    "PowerEdge_15": 3,
    "PowerEdge_14": 4,
    "VxRail_14" : 5,
    "XC_14" : 6,
    "PowerEdge_13": 7,
    "VxRail_13" : 8,
    "XC_13" : 9,
    "PowerEdge_12": 10,
    "ProLiant_G1": 11,
    "ProLiant_G9": 12,
    "SuperMicro": 13,
    "Cisco": 14,
    "Precision_16": 15,
    "Precision_15": 16,
    "Precision_14": 17,
    "Precision_13": 18,
    "Precision_12": 19,
    "Precision_11": 20,
    "Precision_10": 21
};

function getContentfulCollection(){
   const apiUrl = `https://apiapi.ombligo.com/n_contentful/collection/${collectionHandle}/`;

   fetch(apiUrl)
   .then(response => response.json())
   .then(data => {
    console.log('Contentful collection data fetched successfully:', data);

       const title = data.items?.[0]?.fields?.collectionTitle || '';
       const subtitle = data.items?.[0]?.fields?.collectionSubTitle || '';
       if (title == '' && subtitle == "") {
           console.warn('No title or subtitle found in the collection data.');
           return;
       }
           fillTitleText(title, '#collection_title');
           if (subtitle !== undefined){
               fillSubtitleText(subtitle, '#collection_description');
           }
           parseDescription(data);
   })
   .catch(error => {
       console.log('Likely No Data:', error);
   });
}

function fillTitleText(data, titleContainer){
    titleContainer = document.querySelector(titleContainer);
    if (titleContainer){
        titleContainer.innerHTML = data;
    }
}

function fillSubtitleText(data){
    subtitleContainer = document.querySelector('#collection_subtitle');
    if (subtitleContainer) {
        subtitleContainer.innerHTML = data;
    }
}
function fillDescriptionText(data, descriptionContainer){
    descriptionContainer = document.querySelector(descriptionContainer);
    descriptionContainer.innerHTML = data;
}
function parseDescription(data) {
    if (data.items[0].fields.collectionDescriptionLeftSection?.content) {
        const contentNodes = data.items[0].fields.collectionDescriptionLeftSection.content;
        let parsedHtml = '';
        contentNodes.forEach(node => {
            parsedHtml += parseRichText(node);
        });
        fillDescriptionText(parsedHtml, "#collection_description_left");
    }

    if (data.items[0].fields.collectionDescriptionRightSection?.content) {
        const contentNodes = data.items[0].fields.collectionDescriptionRightSection.content;
        let parsedHtml = '';
        contentNodes.forEach(node => {
            parsedHtml += parseRichText(node);
        });
        fillDescriptionText(parsedHtml, "#collection_description_right");
    }

    if (data.items[0].fields.collectionDescription?.content) {
        const contentNodes = data.items[0].fields.collectionDescription.content;
        let parsedHtml = '';
        contentNodes.forEach(node => {
            parsedHtml += parseRichText(node);
        });
        fillDescriptionText(parsedHtml, "#collection_description");
    }

    if (data.includes?.Asset && data.includes.Asset[0]) {
        const imageData = data.includes.Asset[0].fields;
        const imageURL = imageData.file.url.replace('//', 'https://');
        const image = createElement('img', 'collectionImage', '', {
            src: imageURL,
            alt: imageData.description,
            title: imageData.title,
            width: '149px',
            height: '149px'
        });
        document.getElementById('collection_split_image').appendChild(image);
    }
}


function parseProducts(allproducts) {
    const products = allproducts;
    const ctoMinPrices = JSON.parse(localStorage.getItem('ctoMinPrices'));
    let productsByBrand = {};

    for (let i = 0; i < products.length; i++) {
        const brand = products[i].productDetails.brandFilter;
        if (products[i].generation === "8" && products[i].brand === "HP") continue;
        if (products[i].generation === "12" && products[i].brand === "Dell") continue;

        if (productsByBrand[brand]) {
            productsByBrand[brand].push(products[i]);
        } else {
            productsByBrand[brand] = [products[i]];
        }

    }

    for (const brand in productsByBrand) {
    const brandProducts = productsByBrand[brand];
    let cheapestProducts = {};

    for (let i = 0; i < brandProducts.length; i++) {
        const model = brandProducts[i].productDetails.model;
        const handle = brandProducts[i].productDetails.handle;


        if (!cheapestProducts[model] || cheapestProducts[model].productDetails.minPrice > brandProducts[i].productDetails.minPrice) {
            cheapestProducts[model] = brandProducts[i];
        }
    }

    productsByBrand[brand] = Object.values(cheapestProducts);
    }

    return productsByBrand;
}


function createBrandSection(productBrandLine, parent) {
    if (!productBrandLine) return;
    if (productBrandLine.length === 0) return;
    if (productBrandLine[0].productDetails.generation == "8" && productBrandLine[0].productDetails.brand == "HP") return;
    if (productBrandLine[0].productDetails.generation == "12" && productBrandLine[0].productDetails.brand == "Dell") return;


    let vendor = productBrandLine[0].productDetails.brand;
    let gen = productBrandLine[0].productDetails.generation;
    let product_line = productBrandLine[0].productDetails.product_line;

    let brandNotFilter = productBrandLine[0].productDetails.brand;
    let brand = productBrandLine[0].productDetails.brandFilter;
    let brandSection = document.createElement('div');
    brandSection.classList.add('brand-section');
    brandSection.id = brandNotFilter.replaceAll('_','-').toLowerCase();

    let brandTitle = document.createElement('h2');
    brandTitle.classList.add('brand-title');

    if (product_line !== "Precision" ){
      brandTitle.innerText = brand.replaceAll('_', ' ') + ' Servers';
    } else {
      brandTitle.innerText = brand.replaceAll('_', ' ') + " Workstations";
    }
    brandSection.appendChild(brandTitle);

    let brandDescription = document.createElement('div');
    brandDescription.classList.add('brand-description');
    brandDescription.classList.add('brand-description-skeleton');
    brandDescription.id = brand.replaceAll('_','-').toLowerCase() + '-description';
    brandSection.appendChild(brandDescription);

    let productsContainer = document.createElement('div');
    productsContainer.id = brand;
    productsContainer.classList.add('products-container');
    brandSection.appendChild(productsContainer);

    parent.appendChild(brandSection);


    productBrandLine.sort((a, b) => a.rank - b.rank);


    for (let i = 0; i < productBrandLine.length; i++) {
        createProducts(productBrandLine, 800, brand);
    }



    let quickNavText = '';
    if (product_line == "Precision" || vendor == "SuperMicro") {  
    if (vendor !== "SuperMicro") {
        quickNavText = `${vendor} ${product_line} `;
    } else {
        quickNavText = `${vendor} Servers`;
    }
    } else {
    quickNavText = `${vendor} ${product_line} ${gen}th Gen`;
    }

    const quickNavContainer = document.getElementById('quickNavContainer');
    const quickNavNavBar = document.getElementById('quickNavNavBar');

    let quickNav = document.createElement('div');
    quickNav.id = brandNotFilter.replaceAll('_','-').toLowerCase() + '-quickNav';
    quickNav.classList.add('quickNav');
    quickNav.innerHTML = `${quickNavText}`;
    quickNav.onclick = function() {

    document.getElementById(brand).scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
    }

    quickNavContainer.appendChild(quickNav);

    let quickNavClone = quickNav.cloneNode(true);
    quickNavClone.onclick = quickNav.onclick;
    quickNavClone.classList.add('quickNavClone');
    quickNavNavBar.appendChild(quickNavClone);

    if (!document.getElementById(brandNotFilter.replaceAll('_','-').toLowerCase() + '-brand-section-quickNav')) {   
    let brandSectionQuickNav = document.createElement('div');
    brandSectionQuickNav.classList.add('quickNav');
    brandSectionQuickNav.id = brandNotFilter.replaceAll('_','-').toLowerCase() + '-brand-section-quickNav';
    brandSectionQuickNav.innerHTML = `${brandNotFilter.replaceAll('_', ' ')}`;
    brandSectionQuickNav.onclick = function() {
        document.getElementById(brandNotFilter.replaceAll('_','-').toLowerCase()).scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
    }
    quickNavNavBar.appendChild(brandSectionQuickNav);
    }

    if (document.getElementsByClassName('quickNavClone').length > 0) {

    let quickNavClones = Array.from(quickNavNavBar.getElementsByClassName('quickNavClone'));

    quickNavClones.forEach(clone => quickNavNavBar.removeChild(clone));

    quickNavClones.sort((a, b) => {
        const aBrand = Object.keys(rankMap).find(key => a.innerHTML.replaceAll(' ','_').includes(key));
        const bBrand = Object.keys(rankMap).find(key => b.innerHTML.replaceAll(' ','_').includes(key));

        const aRank = rankMap[aBrand] !== undefined ? rankMap[aBrand] : Infinity;
        const bRank = rankMap[bBrand] !== undefined ? rankMap[bBrand] : Infinity;

        if (aRank === bRank) {
            return a.innerHTML.localeCompare(b.innerHTML);
        } else {
            return aRank - bRank;
        }
    });
    quickNavClones.reverse();

    quickNavClones.forEach(clone => quickNavNavBar.insertBefore(clone, document.getElementById(clone.id.replace('quickNav', 'brand-section-quickNav')).nextSibling));
    }


    observeBrandSection(brandSection, quickNavClone);
}


function observeBrandSection(brandSection, quickNav) {
    const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.5
    };

    let debounceTimeoutBS;
    const debounce = (callback, delay) => {
    clearTimeout(debounceTimeoutBS);
    debounceTimeoutBS = setTimeout(callback, delay);
    };

    const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            debounce(() => {
                document.querySelectorAll('.quickNavClone').forEach(nav => {
                    if (!nav.id.includes(quickNav.id)) {
                        nav.style.opacity = '0';
                        nav.style.border = 'none';
                        setTimeout(() => {
                            nav.style.display = 'none';
                        }, 60);    
                    
                    } else {
                        nav.style.opacity = '1';
                        nav.style.border = '2px solid #0095ff';
                        setTimeout(() => {
                            nav.style.display = 'block';
                        }, 100);
                    }
                });
                quickNav.style.display = 'block';
            }, 75); 
        }
    });
    }, observerOptions);

    observer.observe(brandSection);
}


function observeQuickNavContainer() {
    const quickNavContainer = document.getElementById('quickNavContainer');
    const quickNavNavBar = document.getElementById('quickNavNavBar');

    const observerOptions = {
        root: null, 
        rootMargin: "0px",
        threshold: 0 
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                quickNavNavBar.style.display = 'none';
            } else {
                quickNavNavBar.style.display = 'flex';
            }
        });
    }, observerOptions);

    observer.observe(quickNavContainer);
}


const quickNavNavBar = document.querySelector('.quickNavNavBar');

let isDown = false;
let startX;
let scrollLeft;

quickNavNavBar.addEventListener('mousedown', (e) => {
isDown = true;
quickNavNavBar.classList.add('active');
startX = e.pageX - quickNavNavBar.offsetLeft;
scrollLeft = quickNavNavBar.scrollLeft;
});

quickNavNavBar.addEventListener('mouseleave', () => {
isDown = false;
quickNavNavBar.classList.remove('active');
});

quickNavNavBar.addEventListener('mouseup', () => {
isDown = false;
quickNavNavBar.classList.remove('active');
});

quickNavNavBar.addEventListener('mousemove', (e) => {
if (!isDown) return;  
e.preventDefault();
const x = e.pageX - quickNavNavBar.offsetLeft;
const walk = (x - startX) * 2; 
quickNavNavBar.scrollLeft = scrollLeft - walk;
});

let createdFromLocalStorage = false;
let productsOnPage = [];

function clearPoP(){
    localStorage.removeItem('productsOnPage');
    localStorage.removeItem('productsOnPageLastUpdated');
    localStorage.removeItem('sortedSBB');

}


if (localStorage.getItem('productsOnPage') && localStorage.getItem('productsOnPageLastUpdated')) {

    if (JSON.parse(localStorage.getItem('productsOnPage')).length < 25){
        console.log('removing products on page because less than 25');
        clearPoP();
    }
    if (Date.now() - localStorage.getItem('productsOnPageLastUpdated') > 300000){ // 5 minutes
        console.log('removing products on page because more than 5 minutes');
        clearPoP();
    }
    if (window.location.href.includes('sort_by')){
        console.log('removing products on page because sort by');
        clearPoP();
    }
}


    createdFromLocalStorage = false;
    productsOnPage = [];


    function setParametersInPaginationButtons(){      
        pagniationButtonsContainer = document.getElementById('collection-pages');
        paginationButtons = pagniationButtonsContainer.querySelectorAll(".page");
        paginationNextOrPreviouseButtons = pagniationButtonsContainer.querySelectorAll(".next, .previous");

        paginationButtons.forEach((button) => {
                hyperlink = button.querySelector('a');
                if (hyperlink &&  !hyperlink.href.includes('pagesize=')) {
                        href = hyperlink.href.split('?')[0] + '?pagesize={{pageSize}}' + '&' + hyperlink.href.split('?')[1];
                        hyperlink.href = href
                }
        });
        paginationNextOrPreviouseButtons.forEach((button) => {
                hyperlink = button.querySelector('a');
                if (hyperlink &&  !hyperlink.href.includes('pagesize=')) {
                        href = hyperlink.href.split('?')[0] + '?pagesize={{pageSize}}' + '&' + hyperlink.href.split('?')[1];
                        hyperlink.href = href
                }
        });
    }


      
    function testURLEventListener(el){
        let url = el.getAttribute('baseurl');
        let backupurl = el.getAttribute('backupurl');
        fetch(url, { method: 'HEAD' })
        .then(response => {
          if (response.status === 404) {
            el.setAttribute('href', backupurl); 
        } else {
            el.setAttribute('href', url);
          }
        })

    }


    function createProductCard(product, collection) {
        if (product.inventory_quantity === 0) {
            return;
        }
        const prodModelMap = {
            "r740xd": "R740",
            "r740xd2": "R740",
            'r730xd': 'R730',
            'r730xd2': 'R730',
        };
    
        if (product.title && product.handle && product.firstImage) {
            const productHandleUnderScore = product.handle.replace(/-/g, '_');
            const productModel = prodModelMap[product.model.replaceAll(' ', '-').toLowerCase()] || product.model.replaceAll(' ', '-');
            const baseurl = `/collections/${product.brand}-${product.product_line.replaceAll(' ', '-')}-${productModel.replace('xd', '')}?version=${product.sku}`;
            const backupurl = `/collections/configure-to-order-servers/products/${product.handle}`;
    
            const productCard = createElement('a', '', '', {
                style: 'max-height:500px;',
                title: product.title,
                baseurl: baseurl,
                backupurl: backupurl,
                onmouseover: 'testURLEventListener(this)',
                ontouchstart: 'testURLEventListener(this)',
            });
    
            const productContainer = createElement('div', 'mcc-item', '', { id: 'md-chass-container' });
            productCard.appendChild(productContainer);
    
            const productImage = createElement('img', 'mp-img mcc-image lazyload', '', {
                id: 'md-Chass-image',
                fetchpriority: 'high',
                loading: 'eager',
                srcset: product.srcSet,
                sizes: '(max-width: 480px) 159px, (max-width: 800px) 318px, (max-width: 1200px) 480px',
                width: '480',
                height: '480',
                'data-first-src': product.firstImage,
                alt: product.imageAlt,
                'data-second-src': product.secondImagePreview,
                'data-second-full-src': product.secondImage,
                onmouseover: 'loadFullImage(this)',
                onmouseout: 'swapToOgImage(this)'
            });
            productContainer.appendChild(productImage);
    
            const titleContainer = createElement('div', 'skeleton_text mdText', '', { id: 'SkeletonPlaceholder' });
            productContainer.appendChild(titleContainer);
    
            const productTitle = createElement('p', 'md-chass-title fullTitle', '', { id: 'md-Chass-title' });
            updateElementContent(productTitle, product.model.includes(product.product_line) ? 
                `${product.brand} ${product.model}` : 
                `${product.brand} ${product.product_line} ${product.model}`);
            titleContainer.appendChild(productTitle);
    
            const productDescription = createElement('div', 'md-chass-description md-chass-description-skeleton', product.title, {
                id: `${product.model.replace('VxRail ', '').replaceAll(' ', '-')}-description`
            });
            productContainer.appendChild(productDescription);
    
            const productPrice = createElement('p', `mcc-price price-${productHandleUnderScore}`, '', { id: 'md-Chass-Price' });
            updateElementContent(productPrice, `Starting at: ${product.price.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}`);
            productContainer.appendChild(productPrice);
    
            const configureButton = createElement('div', 'mcc-configure-button', '', { id: 'md-Chass-Configure-button' });
            if (product.inventory_quantity === 0) {
                configureButton.style.backgroundColor = '#d3d3d3';
                updateElementContent(configureButton, `
                    <svg class="md-chass-configure-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff">
                        <path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/>
                    </svg>
                    Out of Stock`);
            } else {
                updateElementContent(configureButton, `
                    <svg class="md-chass-configure-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff">
                        <path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/>
                    </svg>
                    View`);
            }
            productContainer.appendChild(configureButton);
    
            return productCard;
        }
    }
    try{
        document.getElementById("products-of-collection-container").appendChild(createProductCard(product, collection));
    } catch (error){

    }      


function createProducts(products, pageSize, parent){ 

    //document.getElementById(parent).innerHTML = '';

    if (products.length === 0){
       const noProductsContainer = document.createElement('div');
        noProductsContainer.setAttribute('id', 'noProductsContainer');
        noProductsContainer.setAttribute('class', 'noProductsContainer');
        noProductsContainer.innerHTML = 'No products match this filter set.';
        
        const resetButton = document.createElement('button');
        resetButton.setAttribute('id', 'resetButton');
        resetButton.setAttribute('class', 'resetFilters');
        resetButton.innerHTML = 'Reset Filters';
        resetButton.addEventListener('click', function(){ resetCTOFilters(); });
        noProductsContainer.appendChild(resetButton);
        document.getElementById(parent).appendChild(noProductsContainer);
        return;
    }

    window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });

      var sortOptions = ["manual", "best-selling", "title-ascending", "title-descending", "price-ascending", "price-descending", "created-ascending", "created-descending"];
    products.sort((a, b) => b.rank - a.rank);
    products = products.reverse();

     products.sort((a, b) => {
        const aInventory = parseInt(a.inventory_quantity);
        const bInventory = parseInt(b.inventory_quantity);

        if (aInventory === 0 && bInventory !== 0) return 1;
        if (bInventory === 0 && aInventory !== 0) return -1;
        return 0;
    });

    

    if (document.getElementById(parent)) document.getElementById(parent).innerHTML = '';

        for (let i = 0; i < products.length; i++) {
            let product = products[i].productDetails;
            let collection = products[i].collection;
            try{
                document.getElementById(parent).appendChild(createProductCard(product, collection));
            } catch (error){
               // console.log(error);
            }
        }
    

    

    productsOnPage = [];

}

// Product Card

function swapToOgImage(imgElement) {
    const fullSrc = imgElement.getAttribute('data-second-full-src');
    const ogSrc = imgElement.getAttribute('data-og-src');
    if (!fullSrc.includes( 'no-image')){

    imgElement.src = ogSrc;
  }
  }
  function loadFullImage(imgElement) {
    const preSrc = imgElement.getAttribute('data-second-src');
    const fullSrc = imgElement.getAttribute('data-second-full-src');
    if (fullSrc === null) {
      return;
    }
    if (!fullSrc.includes( 'no-image')){

    const fullImage = new Image();
    imgElement.setAttribute('data-og-src', imgElement.getAttribute('src'));
    imgElement.style.imageRendering = 'pixelated';
    imgElement.src = preSrc;

    fullImage.src = fullSrc;
    fullImage.onload = function() {
      imgElement.style.imageRendering = 'auto';
      imgElement.src = fullSrc;
    };
  }
  }


  

// Linked Resources



async function setupCTOContentResources(data) {
    var CTOContentResourcesContainer = document.querySelector('#CTOContentResourcesContainer');
    var resourceData = data;
    var resourceLink = resourceData.linkToResource;
    var resourceDescription = resourceData.description.content;

    var image = await fetchEntry("assets", resourceData.image.sys.id);
    var imageURL = image.fields.file.url.replace('//', 'https://');
    var imageDescription = image.fields.description;

    var parsedDescription = '';

    
    resourceDescription.forEach(node => {
        parsedDescription += parseRichText(node);
    });

    const resourceContainer = document.createElement('div');
    resourceContainer.classList.add('resourceContainer');

    const resourceImageContainer = document.createElement('div');
    resourceImageContainer.classList.add('resourceImageContainer');
    

    const resourceImage = document.createElement('img');
    resourceImage.src = imageURL + '?w=159';
    resourceImage.alt = imageDescription;
    resourceImage.classList.add('resourceImage');
    resourceImage.classList.add('lazyload');
    resourceImage.srcset = `
        ${imageURL}?w=159 159w,
        ${imageURL}?w=318 318w,
        ${imageURL}?w=300 480w,
        `;
    resourceImage.sizes = '(max-width: 159px) 159px, (max-width: 318px) 318px, (max-width: 480px) 480px';
    resourceImage.width = '159';
    resourceImage.height = '159';
    const resourceTitle = document.createElement('h3');
    resourceTitle.classList.add('resourceTitle');
    resourceTitle.innerHTML = resourceData.title;

    const resourceDescriptionContainer = document.createElement('div');
    resourceDescriptionContainer.classList.add('resourceDescriptionContainer');
    resourceDescriptionContainer.innerHTML = parsedDescription;

    const resourceLinkElem = document.createElement('a');
    resourceLinkElem.classList.add('resourceLink');
    resourceLinkElem.href = resourceLink;
    resourceLinkElem.title = resourceData.title;

    resourceImageContainer.appendChild(resourceImage);
    resourceLinkElem.appendChild(resourceImageContainer);
    resourceLinkElem.appendChild(resourceTitle);
    resourceLinkElem.appendChild(resourceDescriptionContainer);
    resourceContainer.appendChild(resourceLinkElem);
    CTOContentResourcesContainer.appendChild(resourceContainer);
}

async function setupCTOContentData(data) {
    title = data.fields.sectionTitle;
    sectionDescription = data.fields.sectionDescription.content;
    resourcesToDisplay = data.fields.resourcesToDisplay;
    let parsedDescription = '';

    sectionDescription.forEach(node => {
        parsedDescription += parseRichText(node);
    });

    fillTitleText(title, "#CTOContentTitle");
    fillDescriptionText(parsedDescription, "#CTOContentDescription");
    var entries = await retrieveLinkedEntries(resourcesToDisplay);
    for (const entry of entries) {
        await setupCTOContentResources(entry);
    }
    //await setupCTOContentResources(entries);
}

function fillSubtitleText(data) {
    subtitleContainer = document.querySelector('#collection_subtitle');
    subtitleContainer.innerHTML = data;
}

function getContentfulCTOFooter() {
   const apiUrl = `https://apiapi.ombligo.com/n_contentful/all/ctoSelectionContent/`;

   fetch(apiUrl)
   .then(response => response.json())
   .then(data => {
       const items = data.items;
       const lastItem = items[0];
       setupCTOContentData(lastItem);
   })
   .catch(error => {
       console.error('Error fetching data:', error);
   });
}




    const PLDSVGMap = {
        'Storage': '<svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#5f6368"><path d="M120-160v-160h720v160H120Zm80-40h80v-80h-80v80Zm-80-440v-160h720v160H120Zm80-40h80v-80h-80v80Zm-80 280v-160h720v160H120Zm80-40h80v-80h-80v80Z"/></svg>',
        'Gaming': '<svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#5f6368"><path d="M160-240q-33 0-56.5-23.5T80-320v-320q0-33 23.5-56.5T160-720h640q33 0 56.5 23.5T880-640v320q0 33-23.5 56.5T800-240H160Zm0-80h640v-320H160v320Zm120-40h80v-80h80v-80h-80v-80h-80v80h-80v80h80v80Zm300 0q25 0 42.5-17.5T640-420q0-25-17.5-42.5T580-480q-25 0-42.5 17.5T520-420q0 25 17.5 42.5T580-360Zm120-120q25 0 42.5-17.5T760-540q0-25-17.5-42.5T700-600q-25 0-42.5 17.5T640-540q0 25 17.5 42.5T700-480ZM160-320v-320 320Z"/></svg>',
        'BeastMode' : '<svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#5f6368"><path d="M180-475q-42 0-71-29t-29-71q0-42 29-71t71-29q42 0 71 29t29 71q0 42-29 71t-71 29Zm180-160q-42 0-71-29t-29-71q0-42 29-71t71-29q42 0 71 29t29 71q0 42-29 71t-71 29Zm240 0q-42 0-71-29t-29-71q0-42 29-71t71-29q42 0 71 29t29 71q0 42-29 71t-71 29Zm180 160q-42 0-71-29t-29-71q0-42 29-71t71-29q42 0 71 29t29 71q0 42-29 71t-71 29ZM266-75q-45 0-75.5-34.5T160-191q0-52 35.5-91t70.5-77q29-31 50-67.5t50-68.5q22-26 51-43t63-17q34 0 63 16t51 42q28 32 49.5 69t50.5 69q35 38 70.5 77t35.5 91q0 47-30.5 81.5T694-75q-54 0-107-9t-107-9q-54 0-107 9t-107 9Z"/></svg>',
        'Single Socket': '<svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#5f6368"><path d="M360-360v-240h240v240H360Zm80-80h80v-80h-80v80Zm-80 320v-80h-80q-33 0-56.5-23.5T200-280v-80h-80v-80h80v-80h-80v-80h80v-80q0-33 23.5-56.5T280-760h80v-80h80v80h80v-80h80v80h80q33 0 56.5 23.5T760-680v80h80v80h-80v80h80v80h-80v80q0 33-23.5 56.5T680-200h-80v80h-80v-80h-80v80h-80Zm320-160v-400H280v400h400ZM480-480Z"/></svg>',
        'Dual Socket': '<svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#5f6368"><path d="M360-360v-240h240v240H360Zm80-80h80v-80h-80v80Zm-80 320v-80h-80q-33 0-56.5-23.5T200-280v-80h-80v-80h80v-80h-80v-80h80v-80q0-33 23.5-56.5T280-760h80v-80h80v80h80v-80h80v80h80q33 0 56.5 23.5T760-680v80h80v80h-80v80h80v80h-80v80q0 33-23.5 56.5T680-200h-80v80h-80v-80h-80v80h-80Zm320-160v-400H280v400h400ZM480-480Z"/></svg>',
        'DataMining': '<svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#5f6368"><path d="M200-120q-51 0-72.5-45.5T138-250l222-270v-240h-40q-17 0-28.5-11.5T280-800q0-17 11.5-28.5T320-840h320q17 0 28.5 11.5T680-800q0 17-11.5 28.5T640-760h-40v240l222 270q32 39 10.5 84.5T760-120H200Zm0-80h560L520-492v-268h-80v268L200-200Zm280-280Z"/></svg>',
        'Networking' : '<svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#5f6368"><path d="M220-80q-58 0-99-41t-41-99q0-58 41-99t99-41q18 0 35 4.5t32 12.5l153-153v-110q-44-13-72-49.5T340-740q0-58 41-99t99-41q58 0 99 41t41 99q0 48-28 84.5T520-606v110l154 153q15-8 31.5-12.5T740-360q58 0 99 41t41 99q0 58-41 99t-99 41q-58 0-99-41t-41-99q0-18 4.5-35t12.5-32L480-424 343-287q8 15 12.5 32t4.5 35q0 58-41 99t-99 41Zm520-80q25 0 42.5-17.5T800-220q0-25-17.5-42.5T740-280q-25 0-42.5 17.5T680-220q0 25 17.5 42.5T740-160ZM480-680q25 0 42.5-17.5T540-740q0-25-17.5-42.5T480-800q-25 0-42.5 17.5T420-740q0 25 17.5 42.5T480-680ZM220-160q25 0 42.5-17.5T280-220q0-25-17.5-42.5T220-280q-25 0-42.5 17.5T160-220q0 25 17.5 42.5T220-160Z"/></svg>',
        'Effecient' : '<svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#5f6368"><path d="M480-160q-56 0-105.5-17.5T284-227l-56 55q-11 11-28 11t-28-11q-11-11-11-28t11-28l55-55q-32-41-49.5-91T160-480q0-134 93-227t227-93h320v320q0 134-93 227t-227 93Zm0-80q100 0 170-70t70-170v-240H480q-100 0-170 70t-70 170q0 39 12 74.5t33 64.5l207-207q11-11 28-11t28 11q12 12 12 28.5T548-491L341-284q29 21 64.5 32.5T480-240Zm0-240Z"/></svg>',
        'GPU':'<svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#5f6368"><path d="M160-120q-33 0-56.5-23.5T80-200v-560q0-33 23.5-56.5T160-840h560q33 0 56.5 23.5T800-760v80h80v80h-80v80h80v80h-80v80h80v80h-80v80q0 33-23.5 56.5T720-120H160Zm0-80h560v-560H160v560Zm80-80h200v-160H240v160Zm240-280h160v-120H480v120Zm-240 80h200v-200H240v200Zm240 200h160v-240H480v240ZM160-760v560-560Z"/></svg>',

    }   

function setProductCardDescriptions(mld){
  
        mld.forEach(async item => {
            const productCardDescription = item.productCardDescription;
            const productModel = item.model + '-description';
            let pld = parseRichText(productCardDescription).split(',');
            let desc = parseRichText(productCardDescription);
            let description = '';
            pld.forEach((element) => {
                element = element.replaceAll('<p>', '').replaceAll('</p>', '');
                element = element.trim();
                let elClass = element.replace(' ', '-');
                if (PLDSVGMap[element] !== undefined){
                    description += `<span class="pldBubble pldBubble-${elClass}">${PLDSVGMap[element]}  ${element}</span>`;
                } else {
                    description += `<span class="pldBubble pldBubble-${elClass}">${element}</span>`;
                }
            });
            const elem = document.getElementById(productModel);
            if (elem) {
                elem.innerHTML = desc;
            }


        });
    }


  function setupProductLineDescriptions(items) {
    items.forEach(async item => {
        if (item.fields.modelLineDescriptions !== undefined){
            let mld = await retrieveLinkedEntries(item.fields.modelLineDescriptions);
            setProductCardDescriptions(mld);
        }
        const productLineDescription = item.fields.description;
        const productLineID = item.fields.productLineId    
         + '-description';
        let description = '';
        
        container = document.getElementById(productLineID);
        if (container) {
            container.innerHTML = parseRichText(productLineDescription);
            container.classList.remove('brand-description-skeleton');
        }
    });
}


function getContentdulLineDescriptions() {
   const apiUrl = `https://apiapi.ombligo.com/n_contentful/all/productLineDescription/`;

   fetch(apiUrl)
   .then(response => response.json())
   .then(data => {
       const items = data.items;

      // setupProductLineDescriptions(items);
   })
   .catch(error => {
       console.error('Error fetching data:', error);
   });
}

async function getContentfulContentType(contentType) {
    const apiUrl = `https://apiapi.ombligo.com/n_contentful/all/${contentType}/`;

    try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Error fetching data:', error);
        return null;
    }
}

clearPoP();
getContentfulCollection();
getContentfulCTOFooter();
observeQuickNavContainer();
